var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2469 10C17.2469 7.88333 16.2552 5.99167 14.7136 4.775L14.1469 1.39167C14.0136 0.591667 13.3136 0 12.5052 0H8.66357C7.84691 0 7.14691 0.591667 7.01357 1.39167L6.45524 4.775C4.90524 5.99167 3.91357 7.875 3.91357 10C3.91357 12.125 4.90524 14.0083 6.45524 15.225L7.01357 18.6083C7.14691 19.4083 7.84691 20 8.66357 20H12.5052C13.3219 20 14.0136 19.4083 14.1469 18.6083L14.7136 15.225C16.2552 14.0083 17.2469 12.1167 17.2469 10ZM5.58024 10C5.58024 7.24167 7.82191 5 10.5802 5C13.3386 5 15.5802 7.24167 15.5802 10C15.5802 12.7583 13.3386 15 10.5802 15C7.82191 15 5.58024 12.7583 5.58024 10Z",
    fill: "#065A15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIconSmall);
export default __webpack_public_path__ + "static/media/watch-icon-small.88cc2e14c2d676b19e3f5280a44ca734.svg";
export { ForwardRef as ReactComponent };